import _ from 'lodash';

export const validateHasChangedWithValue = (value, stateValue) => {
  return (
    !_.isEqual(value || '', stateValue || '') &&
    (!_.isObject(stateValue) ||
      _.isArray(stateValue) ||
      (!_.isArray(stateValue.regex_pattern) &&
        !_.isEmpty(stateValue.regex_pattern) &&
        !_.isNull(stateValue.regex_pattern)))
  );
};

export const validateHasChangedWithoutValue = (value, stateValue) => {
  return !_.isEqual(value || '', stateValue || '');
};
